import React, { Component, createRef } from 'react';
import ReactDOM from "react-dom";
import { QRCodeCanvas } from "qrcode.react";
import * as htmlToImage from "html-to-image";


export default class QRcode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default state
        };
        this.qrRef = createRef();

        /* Functions to and upload usage data */

    }


    handleCopy = async () => {
        const dataUrl = await htmlToImage.toPng(this.qrRef.current);
        const blob = await (await fetch(dataUrl)).blob();
        await navigator.clipboard.write([
            new window.ClipboardItem({ "image/png": blob })
        ]);
        alert("QR code copied to clipboard!");
    };

    /* handleDownload = async () => {
        const dataUrl = await htmlToImage.toPng(this.qrRef.current);
        const link = document.createElement("a");
        link.download = "guidr-qr.png";
        link.href = dataUrl;
        link.click();
    }; */

    handleDownload = async () => {
        const node = this.qrRef.current;
        const viewW = node.getBoundingClientRect().width;
        const scale = 1024 / viewW;

        // toPng will redraw the canvas internally at viewW * pixelRatio
        const dataUrl = await htmlToImage.toPng(node, {
            pixelRatio: scale
        });

        const link = document.createElement("a");
        link.download = "guidr-qr.png";
        link.href = dataUrl;
        link.click();
    };

    render() {

        return (

            <div className="account__section">
                <div className="account__element">
                    {/* QR code */}
                    <div className="popup__qr__code-wrapper">
                        <div ref={this.qrRef} className="popup__qr__code">
                            <QRCodeCanvas
                                value={this.props.url}
                                size={1024}
                                style=""
                                className="popup__qr__code-inner"
                            />
                        </div>
                    </div>
                </div>

                <div className="account__element account__element__buttonbox">
                    <button onClick={this.handleCopy} className={"button button-primary-light"}>
                        Copy to clipboard
                    </button>
                    <button onClick={this.handleDownload} className={"button button-primary-light"}>
                        Download PNG
                    </button>
                </div>
            </div>


        )
    }
}